import Vue from 'vue';
import Router from 'vue-router';
import DefaultContainer from './views/DefaultContainer';
import Login from '@/views/Login';
import AccountCreation from '@/views/AccountCreation';
import HomePage from '@/views/HomePage';
import PathManagement from '@/views/PathManagement';
import PageNotFound from '@/views/404.vue';
import EditAccountInfo from '@/views/EditAccountInfo.vue';
import EditMission from '@/views/EditMission.vue';
import ManagePath from '@/views/ManagePath.vue';
import RequestResetPassword from '@/views/RequestResetPassword.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import Stats from '@/views/Stats.vue';
import Credits from '@/views/Credits.vue';

Vue.use(Router);

export const createRouter = (kuzzle, i18n, store) => {
  const authenticationGuard = async (to, from, next) => {
    try {
      if (await store.dispatch('auth/CHECK_TOKEN', kuzzle)) {
        next();
      } else {
        next({ name: 'login', query: { to: to.name } });
      }
    } catch (error) {
      console.error(error.message);
      next({ name: 'login', query: { to: to.name } });
    }
  };

  const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
      {
        path: '/login',
        name: 'login',
        component: Login,
      },
      {
        path: '/accountCreation',
        name: 'accountCreation',
        component: AccountCreation,
      },
      {
        path: '/requestResetPassword',
        name: 'requestResetPassword',
        component: RequestResetPassword,
      },
      {
        path: '/resetPassword/:token',
        name: 'resetPassword',
        component: ResetPassword,
      },
      {
        path: '/',
        beforeEnter: authenticationGuard,
        component: DefaultContainer,
        children: [
          {
            path: '',
            redirect: 'homePage',
            meta: {
              notInSideBar: true,
              notInToolBar: true,
            },
          },
          {
            path: 'pathsOverview',
            redirect: 'homePage',
            name: 'pathsOverview',
            beforeEnter: authenticationGuard,
            meta: {
              // Add this to take off that child of SideBar component :
              // notInSideBar: true,
              text: {
                fr: i18n.t('sidebar.paths', 'fr'),
                en: i18n.t('sidebar.paths', 'en'),
              },
              icon: 'mdi-map',
              notInToolBar: true,
            },
          },
          {
            path: 'homePage',
            name: 'homePage',
            beforeEnter: authenticationGuard,
            component: HomePage,
            meta: {
              notInToolBar: false,
            },
          },
          {
            path: 'pathManagement/:pathId?',
            name: 'pathManagement',
            beforeEnter: authenticationGuard,
            component: PathManagement,
            meta: {
              notInSideBar: true,
              notInToolBar: false,
            },
          },
          {
            path: 'missionsOverview',
            redirect: 'homePage',
            name: 'missionsOverview',
            beforeEnter: authenticationGuard,
            meta: {
              text: {
                fr: i18n.t('sidebar.missions', 'fr'),
                en: i18n.t('sidebar.missions', 'en'),
              },
              icon: 'mdi-compass',
              notInToolBar: true,
            },
          },{
            path: 'pathSettings/:pathId',
            name: 'pathSettings',
            beforeEnter: authenticationGuard,
            component: ManagePath,
            meta: {
              
              notInSideBar: true,
              notInToolBar: true,
            },
          },
          {
            path: 'editMission/:pathId/:missionId',
            name: 'editMission',
            beforeEnter: authenticationGuard,
            component: EditMission,
            meta: {
              text: {
                fr: i18n.t('missionsOverview.editMission', 'fr'),
                en: i18n.t('missionsOverview.editMission', 'en'),
              },
              notInSideBar: true,
              notInToolBar: true,
            },
          },
          {
            path: 'editAccountInfo/:accountId',
            name: 'editAccountInfo',
            beforeEnter: authenticationGuard,
            component: EditAccountInfo,
            meta: {
              text: {
                fr: i18n.t('sidebar.profil', 'fr'),
                en: i18n.t('sidebar.profil', 'en'),
              },
              icon: 'mdi-account-circle',
              notInToolBar: false,
            },
          },
          /*{
            path: 'credits',
            name: 'credits',
            beforeEnter: authenticationGuard,
            component: Credits,
            meta: {
              text: {
                fr: i18n.t('sidebar.credits','fr'), 
                en: i18n.t('sidebar.credits','en')
              },
              icon: 'mdi-account-circle',
              notInToolBar: false
            }
          },
          */
          {
            path: 'stats/:pathId/',
            name: 'Stats',
            beforeEnter: authenticationGuard,
            component: Stats,
            meta: {
              text: {
                fr: i18n.t('sidebar.stats', 'fr'),
                en: i18n.t('sidebar.stats', 'en'),
              },
              icon: 'mdi-trending-up',
            },
            notInToolBar: true,
          },
        ],
      },
      {
        path: '*',
        component: PageNotFound,
      },
    ],
  });

  router.beforeEach(async (to, from, next) => {
    /**
     * This route guard ensures that the app is connected to Kuzzle before
     * passing to the next route.
     */
    const offlinePageDelay = 1500;
    return new Promise(async (resolve) => {
      setTimeout(() => {
        if (!store.state.app.online) {
          store.commit('app/SET_WAITING_FOR_CONNECTION');
        }
      }, offlinePageDelay);
      const onceConnected = () => {
        store.commit('app/SET_ONLINE');
        setTimeout(() => {
          store.commit('app/UNSET_WAITING_FOR_CONNECTION');
        }, offlinePageDelay);

        kuzzle.removeListener('connected', onceConnected);
        kuzzle.removeListener('reconnected', onceConnected);

        next();
        return resolve();
      };
      if (!store.state.app.online) {
        kuzzle.addListener('connected', onceConnected);
        kuzzle.addListener('reconnected', onceConnected);
      } else {
        onceConnected();
      }
    });
  });

  return router;
};
